export default __webpack_public_path__ + "daa89524c05e187fc1ffce8001f9945b.svg";